import { PaletteOptions, SimplePaletteColorOptions } from '@mui/material';

interface IPalette extends PaletteOptions {
  third: SimplePaletteColorOptions;
  fourth: SimplePaletteColorOptions;
  fifth: SimplePaletteColorOptions;
  sixth: SimplePaletteColorOptions;
  seventh: SimplePaletteColorOptions;
  eighth: SimplePaletteColorOptions;
  tenth: SimplePaletteColorOptions;
  transparent: SimplePaletteColorOptions;
}

// export type PaletteColorOptions = SimplePaletteColorOptions | ColorPartial;

const primary: SimplePaletteColorOptions = {
  main: '#0086D8',
  light: '#1992dc',
  // dark: '#1B75BB',
  dark: '#4D74FF',
  contrastText: '#fff',
};

const secondary: SimplePaletteColorOptions = {
  main: '#3EB646',
  light: '#75B753',
  dark: '#45C94E',
  contrastText: '#fff',
};

const third: SimplePaletteColorOptions = {
  main: '#D1296D',
  light: '#DA4D7A',
  dark: '#b0275b',
  contrastText: '#fff',
};

const fourth: SimplePaletteColorOptions = {
  main: '#F9BA48',
  light: '#f5b371',
  dark: '#F78E21',
  contrastText: '#fff',
};
const fifth: SimplePaletteColorOptions = {
  main: '#E5E5EA',
  light: '#E5E5EA',
  dark: '#E5E5EA',
  contrastText: '#fff',
};
const sixth: SimplePaletteColorOptions = {
  main: '#C7C7CC',
  light: '#E6E7E8',
  dark: '#A0B3BE',
  contrastText: '#fff',
};

const seventh: SimplePaletteColorOptions = {
  main: '#E02020',
  light: '#DA4D7A',
  dark: '#b0275b',
  contrastText: '#fff',
};

const eighth: SimplePaletteColorOptions = {
  main: '#404040',
  light: '#657480',
  dark: '#000000', // POR DEFINIR , no se utiliza
  contrastText: '#fff',
};

const ninth: SimplePaletteColorOptions = {
  main: '#2C2C2E',
  light: '#',
  dark: '#', // POR DEFINIR , no se utiliza
  contrastText: '#fff',
};

const tenth: SimplePaletteColorOptions = {
  main: '#0E3687',
  light: '#',
  dark: '#', // POR DEFINIR , no se utiliza
  contrastText: '#fff',
};

const transparent: SimplePaletteColorOptions = {
  main: 'rgba(0, 0, 0, 0)',
  light: 'rgba(0, 0, 0, 0)',
  dark: 'rgba(0, 0, 0, 0)',
  contrastText: 'rgba(0, 0, 0, 0)',
};

const paletteConfig: IPalette = {
  mode: 'light',
  primary,
  secondary,
  third,
  fourth,
  fifth,
  sixth,
  seventh,
  eighth,
  ninth,
  tenth,
  transparent,
  success: secondary,
  error: seventh,
  warning: fourth,
  info: primary,
  text: {
    primary: eighth.main,
    secondary: '#333',
    disabled: '#E6E7E8',
  },
  common: {
    black: '#000',
    white: '#fff',
  },
};

const colors = {
  primary,
  secondary,
  third,
  fourth,
  fifth,
  sixth,
  seventh,
  eighth,
  ninth,
  tenth,
  transparent,
};

export default paletteConfig;

export { colors };
